import BigPicture from 'bigpicture'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
	init() {
		bigPictureGallery()
		galleryScrollReveals()
	},
	finalize() {},
}

function bigPictureGallery() {
	let $galleryImage = $('.gallery-image-wrap > img')
	if ($galleryImage.length) {
		$galleryImage.on('click', function (e) {
			e.preventDefault()
			BigPicture({
				el: this,
				gallery: '.gallery-grid',
				loop: true,
			})
		})
	}
}

function galleryScrollReveals() {
	let $galleryItems = $('.gallery-image')
	if ($galleryItems.length) {
		document.querySelectorAll('.gallery-image').forEach((item, index) => {
			gsap.fromTo(
				item,
				{ opacity: 0 },
				{
					scrollTrigger: item,
					delay: 0.5,
					duration: 0.5,
					opacity: 1,
				}
			)
		})
	}
}
